const PRIVACY_STATUS_PRIVATE = 1;
import * as PageMenuConfig from '@fremcast/section/config';
export default {
  data() {
    return {
      menuConfig: PageMenuConfig.default['skrn'].menu,
      privacy: 1,
      website: {},
      page: []
    };
  },

  computed: {
    fetchPageSlug() {
      let website = this.$store.getters['website/website']
      if (website.hasOwnProperty('page')) {
        return this.website.page.uuid
      }
    },
    fetchPageByUuid() {
      return this.$store.getters['website/fetchUuid']
    },
    fetchPages() {
      return this.$store.getters['website/fetchPages']
    }
  },
  mounted() {
    //this.setMenuConfig();
  },
  methods: {
    setMenuConfig() {
      if (this.privacy === PRIVACY_STATUS_PRIVATE && this.menuPages[0].access === 'private') {
        this.menuConfig.accessLink = this.menuConfig.homeLink
      }
    },
    fetchIcon(icon) {
      return _.has(this.menuConfig.icons, icon) ? this.menuConfig.icons[icon] : this.menuConfig.defaultIcon;
    },
    setOffset: function(offset) {
      this.navOffset = offset
    },
  }
}
